export const DELETE_PROMO_CODE_MODAL_NAME = 'DELETE_PROMO_CODE_MODAL_NAME';
